import { settings } from '@/settings'
import { LocalStorage } from 'ttl-localstorage'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const fetch = (url, options) => {
    const { timeout = 20000 } = options
    const controller = new AbortController()
    options.signal = controller.signal
    const id = setTimeout(() => {
        controller.abort("Timeout")
    }, timeout)
    return window.fetch(url, options).then(async response => {
        if (response.ok) {
            return await response.json()
        } else {
            try {
                const reject = await response.json()
                reject.code = response.status
                if (!reject.message) {
                    if (reject.detail) {
                        reject.message = reject.detail
                    } else if (reject.error) {
                        reject.message = reject.error
                    } else {
                        reject.message = 'エラーが発生しました'
                    }
                }
                return Promise.reject(reject)
            } catch (err) {
                return Promise.reject(new Error('サーバーエラーが発生しました。サポートまで問い合わせてください。'))
                // return Promise.reject(err)
            }
        }
    }).finally(()=>{
        clearTimeout(id)
    })
}

export default
{
    get (api, params = null, isAuth = false) {
        const options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                Accept: 'application/json'
            }
        }
        const baseUrl = isAuth ? settings.baseUrl : `${settings.baseUrl}member/`
        const url = new URL(baseUrl + api)
        const token = LocalStorage.get('spoplus-token')
        if (token) {
            options.headers.Authorization = 'Token ' + token
        }
        if (params) {
            for (const key in params) {
                url.searchParams.append(key, params[key])
            }
        }
        return fetch(url, options)
    },
    post (api, params = null, asJSON = true, isAuth = false) {
        const options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application/json'
            }
        }
        if (api !== 'login') {
            const token = LocalStorage.get('spoplus-token')
            if (token) {
                options.headers.Authorization = 'Token ' + token
            }
        }

        if (params) {
            if (asJSON) {
                options.headers['Content-Type'] = 'application/json'
                options.body = JSON.stringify(params)
            } else {
                const formData = new FormData()
                for (const key in params) {
                    formData.append(key, params[key])
                }
                options.body = formData
            }
        }
        const baseUrl = isAuth ? settings.baseUrl : `${settings.baseUrl}member/`
        const url = new URL(baseUrl + api)
        return fetch(url, options)
    },
    delete (api) {
        const options = {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                Accept: 'application/json'
            }
        }
        const token = LocalStorage.get('spoplus-token')
        if (token) {
            options.headers.Authorization = 'Token ' + token
        }
        const baseUrl = `${settings.baseUrl}member/`
        const url = new URL(baseUrl + api)
        return fetch(url, options)
    }
}
